export type LoadingTipsListItem = {
    title: string;
    tips: string | string[];
};
type Key = 'insight' | 'experience';
export const getLoadingTips = function (moduleName: string, i18n: any) {
    const Tips: any = {
        insight: getTipsArray('insight', 19, i18n),
        experience: getTipsArray('experience', 25, i18n)
    };

    return moduleName && i18n ? Tips[moduleName] : [];
};

/**
 * 统一在loading tips前添加Tip：字样
 */
function getTipsArray(key: Key, len: number, i18n: any) {
    if (len <= 0 || !i18n || !key) return [];
    const result = [];
    for (var i = 0; i < len; i++) {
        result.push({
            tips: 'Tip：' + i18n(`loading.${key}.tips_${i + 1}`)
        });
    }
    return result;
}
